import { Container, Row, Col, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './Common.scss';

export default function Activities() {
  return (
    <Container fluid>
      <Row className="justify-content-center">
        <Col lg={12} md={12} sm={12} xs={12} className="mt-4">
          <Card className="shadow-sm slideinBottom">
            <Card.Body className="text-center py-5">
              <h1 className="display-4 mb-4 text-success">
                オーナーの表現活動
              </h1>
              <h2 className="h3 text-muted mb-4">
                ヒーリングサロンGundariのオーナーは、ヒーリングだけでなく、さまざまな表現活動を行っています。興味がある方は、ぜひご覧ください。
              </h2>
              <h2 className="h3 text-muted mb-4">
                自分で言うのもあれですがヒーラーよりも職工人、クリエイター、アーティストの側面が強いかもしれません。
              </h2>
              <hr />
              <h2 className="text-success">小説</h2>
              <p className="lead">
                オーナーは小説を書いています。現在、以下の作品を公開中です。
              </p>
              <Link
                to="https://ncode.syosetu.com/n2225jy/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <h2 className="text-success">「天界との約束」</h2>
              </Link>
              <p className="lead">
                闘病中に書いていた作品のヒロイン「アリア」のキャラ設定だけそのまま踏襲して、MMSで学んだ形而上学やGLAで学んできた神理、哲学的なテーマを交えつつ執筆し直している作品です。
              </p>
              <p className="lead">
                当サイトにもちらほらと出ている狐耳の少女がそれです。
              </p>
              <p className="lead">
                ChatGPTの画像生成機能を使ってヒロインをモチーフにしたLINEスタンプも作っています。
              </p>
              <p className="lead">スタンプは以下のリンクから購入できます。</p>
              <ul className="list-unstyled">
                <li className="mb-2">
                  <a
                    href="https://line.me/S/sticker/30342524/?lang=ja&utm_source=gnsh_stickerDetail"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    [星の聖女アリア]
                  </a>
                </li>
                <li className="mb-2">
                  <a
                    href="https://line.me/S/sticker/30725222/?lang=ja&utm_source=gnsh_stickerDetail"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    [星の聖女アリア(聖女の休日)]
                  </a>
                </li>
              </ul>
              <Link
                to="https://ncode.syosetu.com/n1856gp/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <h2 className="text-success">
                  「創世の女神、間違って転生する」
                </h2>
              </Link>
              <p className="lead">
                2020年か2021年頃に途中まで書いてた作品です。神主として管轄の神社で奉仕していた際に神事の最中に氏子さんが屁をこいたことでアイデアが降りてきたことで執筆してました。
              </p>
              <p className="lead">
                シリアス要素少なめギャグ要素やコメディ要素を重視した作品です。
              </p>
              <p className="lead">
                どちらの作品も小説投稿サイト「小説家になろう」で公開しています。興味がある方は、ぜひご覧ください。
              </p>
              <hr />
              <h2 className="text-success">ワイヤーアート</h2>
              <p className="lead">
                オーナーはワイヤーアートにも取り組んでいます。興味がある方は、ぜひご覧ください。
              </p>
              <h2 className="text-success">作品例</h2>
              <Row>
                <Col lg={4} md={4} sm={12} xs={12} className="mt-4 d-flex">
                  <img
                    src={require('../../images/wire_art.jpeg')}
                    alt="画像は開発中のものです"
                    className="img-fluid"
                  />
                </Col>
                <Col lg={8} md={8} sm={12} xs={12} className="mt-4 d-flex">
                  <Card className="shadow-sm h-100">
                    <Card.Body className="text-center py-5 d-flex flex-column justify-content-center">
                      <h2 className="text-success">ドラゴンのサークリット</h2>
                      <p className="lead">
                        ヒーラーズアカデミー1で出会った中国からの参加者の方に魂・スピリットの側面にドラゴンが含まれていることを教えてもらい、それを表現するアイテムを最初は探してましたが見つからなかったため、自分で作ろうと決意して作った作品です。
                      </p>
                      <p className="lead">
                        完成後MMSの講義で被ってみたところ長時間被ってると重すぎて頭が痛くなることに気づかせてくれた作品でもあります。
                      </p>
                      <p className="lead">
                        先達の方々がサークリットを始め様々なアクセサリーを極力軽量化している理由が身にしみてわかりました。
                      </p>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
              <hr />
              <h2 className="text-success">服のデザイン</h2>
              <p className="lead">
                ヒーラーズアカデミー1で本来の自分の持っている世界観を表現することの大切さを学び、衣装デザインにも興味を持つようになりました。
                イラストアプリでデザインを描き、服職人の方に依頼して服を作ってもらっています。
              </p>
              <h2 className="text-success">作品例</h2>
              <Row>
                <Col lg={4} md={4} sm={12} xs={12} className="mt-4 d-flex">
                  <img
                    src={require('../../images/cloth_design.jpeg')}
                    alt="画像は開発中のものです"
                    className="img-fluid"
                  />
                </Col>
                <Col lg={8} md={8} sm={12} xs={12} className="mt-4 d-flex">
                  <Card className="shadow-sm h-100">
                    <Card.Body className="text-center py-5 d-flex flex-column justify-content-center">
                      <h2 className="text-success">純白のローブ</h2>
                      <p className="lead">
                        ビビラボさんが過去に販売していたセルフこたつ着る毛布2018年モデルのドレスシルエットが気に入っていたのですが、白色が販売されないまま生産終了してしまったため、5年以上もの間類似品を探し続けていましたが、見つからなかったため、オーダーメイド制作を決意しました。
                      </p>
                      <p className="lead">
                        こだわりポイントはセルフこたつ着る毛布2018年モデルのドレスシルエットを完璧な精度で再現してもらうところや、元の製品よりも袖口を広げて、より魔法使いのローブのような雰囲気を演出したこと、後は、ヒーリングの施術用の道具一式を持ち運びしやすくするようポケットを多めにしたことです。
                      </p>
                      <p className="lead">
                        服を制作していただく際お世話になったのはオーダーメイドで服を作ってくださるS
                        for Youの方々です。着てみたいと思う方はS for
                        Youの公式サイト(
                        <a
                          href="https://www.s4u.jp"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          こちら
                        </a>
                        )よりオーナーの新海さんにサロンGundariオーナーの名前(加藤)を伝え、本サイトの服の画像を見せて相談してみるのも良いかもしれません。
                      </p>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
              <hr />
              <h2 className="text-success">組紐</h2>
              <p className="lead">オーナーは組紐にも取り組んでいます。</p>
              <h2 className="text-success">作品例</h2>
              <Row>
                <Col lg={4} md={4} sm={12} xs={12} className="mt-4 d-flex">
                  <img
                    src={require('../../images/kumihimo.jpeg')}
                    alt="画像は開発中のものです"
                    className="img-fluid"
                  />
                </Col>
                <Col lg={8} md={8} sm={12} xs={12} className="mt-4 d-flex">
                  <Card className="shadow-sm h-100">
                    <Card.Body className="text-center py-5 d-flex flex-column justify-content-center">
                      <h2 className="text-success">腰帯</h2>
                      <p className="lead">
                        Xでhyo-tanのオーナーの橋本さんとDMで雑談している間に思いついたアイデアを形にしました。
                      </p>
                      <p className="lead">
                        日本の伝統技術の組紐を使って腰帯を作り、hyo-tanさんで作成されているクリスタルアクセサリーと組み合わせると面白いと思っています。
                      </p>
                      <p className="lead">
                        クリスタルや化石などを使ったオリジナルのアクセサリーが欲しい方は
                        <a
                          href="https://x.com/hyotan786"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          こちら
                        </a>
                        からhyo-tanの橋本さんにDMで相談してみてください。オーナーもヒーリングワンドのオーダーメイドやアクセサリーのオーダーメイドの際にお世話になっています。
                      </p>
                      <p className="lead">
                        hyo-tanの橋本さんは各地で行われるミネラルショーに出店されているのでお近くでイベントがあった際には直接コンタクトを取られるのもおすすめです。
                      </p>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
              <hr />
              <h2 className="text-success">メタバース</h2>
              <p className="lead">
                オーナーはメタバース開発にも取り組んでいます。
              </p>
              <h2 className="text-success">開発中コンテンツ</h2>
              <Row>
                <Col lg={4} md={4} sm={12} xs={12} className="mt-4 d-flex">
                  <video
                    src={require('../../movies/metaverse_compressed.mov')}
                    controls
                    className="img-fluid"
                  />
                </Col>
                <Col lg={8} md={8} sm={12} xs={12} className="mt-4 d-flex">
                  <Card className="shadow-sm h-100">
                    <Card.Body className="text-center py-5 d-flex flex-column justify-content-center">
                      <h2 className="text-success">アルス(仮名)</h2>
                      <p className="lead">
                        VroidHubにアップロードした自分のオリジナルキャラクターでマリオ64とモンハンを合わせたようなコンテンツで遊びたいなと思って作り始めた作品です。
                      </p>
                      <p className="lead">
                        コンテンツの機能として考えているのはオンラインゲーム、形而上学やスピリチュアルの知識を共有できる場所の提供、メタバース教育やVR医療、マーケティングなどです。
                      </p>
                      <p className="lead">
                        最終的にはサマーウォーズのOZのような世界を目指しています。
                      </p>
                      <p className="lead">
                        希望があれば開発進捗とか配信やブログでの報告もするかもしれません。
                      </p>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}
